import { DeliveryMode } from '../../../../../../services/exports/Constants';

export default {
  types: {
    circle: 'Círculo',
    polygon: 'Polígono',
    zip: 'Código postal',
  },
  fields: {
    name: {
      label: 'Nome',
    },
    color: {
      label: 'Cor',
    },
    min_threshold: {
      label: 'Valor mínimo de encomenda',
    },
    max_threshold: {
      label: 'Valor máximo de encomenda',
    },
    fee: {
      [DeliveryMode.Internal]: {
        label: 'Taxa de entrega',
      },
      [DeliveryMode.External]: {
        label: 'Taxa paga pelo restaurante',
      },
    },
    zip_codes: {
      label: 'Códigos postais (um por linha)',
    },
  },
  labels: {
    hidden: '(oculto)',
  },
  buttons: {
    save: 'Guardar',
    cancel_changes: 'Cancelar alterações',
    add_max_order_amount: 'Adicionar valor máximo de encomenda',
  },
  modals: {
    delete_confirmation: {
      title: 'Tem a certeza que pretende eliminar {{name}}',
    },
  },
  toasts: {
    failed_to_save_changes: 'Erro ao guardar as alterações de {{name}}',
    delivery_zone_got_updated: 'Alterações de {{name}} guardadas com sucesso',
    failed_to_delete_delivery_zone: 'Erro ao eliminar {{name}}',
    delivery_zone_got_deleted: '{{name}} eliminado com sucesso',
  },
};
